import produce, { Draft, DraftArray } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import { MediaSource } from '../../../types/media';
import * as actions from './actions';
import { IUploadedMediaItem, UploadStatus } from './types';

export type MediaUploadsState = IUploadedMediaItem[];
export type UploadActions = ActionType<typeof actions>;

function updateItem<T extends IUploadedMediaItem>(
  state: DraftArray<readonly T[]>,
  name: string,
  updater: (props: Draft<T>) => void,
): void {
  const item = state.find((i) => i.name === name);
  if (item) {
    updater(item);
  }
}

function reducer(
  state: MediaUploadsState = [],
  action: UploadActions,
): MediaUploadsState {
  return produce<MediaUploadsState>(state, (draftState) => {
    switch (action.type) {
      case getType(actions.setPreviewImage):
        updateItem(draftState, action.payload.name, (item) => {
          item.previewImage = action.payload.url;
        });
        break;
      case getType(actions.upload.request):
        return [
          {
            ...action.payload,
            source: MediaSource.UPLOAD,
            progress: { total: 1, loaded: 0 },
            status: UploadStatus.NEW,
          },
          ...draftState,
        ];
      case getType(actions.progress):
        updateItem(draftState, action.payload.name, (item) => {
          item.progress = action.payload.progress;
        });
        break;
      case getType(actions.upload.success):
        updateItem(draftState, action.payload.name, (item) => {
          item.status = UploadStatus.OK;
        });
        break;
      case getType(actions.upload.failure):
        updateItem(draftState, action.payload.name, (item) => {
          item.status = UploadStatus.ERROR;
          item.error = action.payload;
        });
        break;
      case getType(actions.toggleSelected):
        updateItem(draftState, action.payload.name, (item) => {
          item.selected = action.payload.selected;
        });
        break;
      case getType(actions.clanUpFailed):
        return draftState.filter((item) => !item.error);

      default:
    }
  });
}

export default reducer;
